import ModalElement from "../../Components/Modal";
import { useEffect, useState } from "react";
import Button from "../../Components/Button";
import { Container, SearchBar } from "./styles";
import { IUserColab } from "../../Interfaces";
import { UserForm } from "../../Components/UserForm";
import { useUser } from "../../Providers/User";
import Footer from "../../Components/Footer";
import { ListCardBox } from "../../Components/ListCardBox";
import CardColaborators from "../../Components/CardColaborators";

const Colaborators = () => {
  const { admAuth, colabList } = useUser();
  const [userInput, setUserInput] = useState("");
  const [filteredColabs, setFilteredColabs] = useState<IUserColab[]>([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const onChangeSearch = (e: any) => {
    setUserInput(e.target.value);
    if (userInput.length > 0) {
      setFilteredColabs(
        colabList.filter((elem) => elem.name.includes(userInput))
      );
    }
  };

  useEffect(() => {}, [colabList]);

  const handleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  return (
    <Container>
      <SearchBar>
        <input onChange={(e) => onChangeSearch(e)} placeholder="procurar" />
        <Button className={"Button"}>Procurar</Button>
      </SearchBar>

      <ListCardBox height="42vh">
        {userInput.length > 0
          ? filteredColabs?.map((colab) => (
              <CardColaborators key={colab.id} colab={colab} />
            ))
          : colabList?.map((colab) => (
              <CardColaborators key={colab.id} colab={colab} />
            ))}
      </ListCardBox>

      <ModalElement
        closeModal={() => setModalIsOpen(false)}
        isOpen={modalIsOpen}
      >
        <UserForm />
      </ModalElement>
      {admAuth && (
        <Button onClick={handleModal} className="addButton">
          Novo
        </Button>
      )}
      <Footer />
    </Container>
  );
};
export default Colaborators;
